(() => {
  'use strict';
  const data = document.getElementById('MediverePackshots');
  if (!data) return;
  let entries;
  try { entries = JSON.parse(data.textContent); } catch { return; }
  const basename = value => {
    try { return decodeURIComponent(new URL(value, location.origin).pathname.split('/').pop()).replace(/_(?:\d+x\d*|\d*x\d+|small|compact|medium|large|grande|master)(?:_crop_[a-z]+)?(?=\.)/g, ''); }
    catch { return ''; }
  };
  const known = new Map(entries.filter(x => x.handle !== 'gamedi-dna-leverpaspoort').map(x => [basename(x.old), x]));
  const update = root => {
    if (!(root instanceof Element || root instanceof Document)) return;
    const imgs = root instanceof HTMLImageElement ? [root] : root.querySelectorAll('img');
    imgs.forEach(img => {
      const sources = [img.getAttribute('src'), img.getAttribute('data-src')].filter(Boolean);
      const entry = sources.map(source => known.get(basename(source))).find(Boolean);
      if (!entry) return;
      const link = img.closest('a[href]');
      if (link && link.getAttribute('href').includes('/products/') && !link.getAttribute('href').includes('/products/' + entry.handle)) return;
      const url = new URL(entry.image);
      url.searchParams.set('width', String(Math.min(1200, Math.max(240, Math.ceil((img.clientWidth || 300) * 2)))));
      const replacement = url.href;
      img.setAttribute('src', replacement);
      ['srcset', 'data-srcset'].forEach(name => img.removeAttribute(name));
      if (img.hasAttribute('data-src')) img.setAttribute('data-src', replacement);
    });
  };
  update(document);
  const observer = new MutationObserver(records => {
    records.forEach(record => {
      if (record.type === 'attributes') update(record.target);
      else record.addedNodes.forEach(update);
    });
  });
  observer.observe(document.body, {childList:true, subtree:true, attributes:true, attributeFilter:['src','data-src']});
})();
